var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _circle, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGRs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 4.61914V22.75C0.25 23.3023 0.697715 23.75 1.25 23.75H12.5",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74805 0.25H16.1241C16.6764 0.25 17.1241 0.697715 17.1241 1.25V11",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.375H0.615234L4.5 0.591797V4.375Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.375H15.25",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.625H15.25",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 6.75L15.25 6.75",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 9L15.25 9",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 11.25L15.25 11.25",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 13.5L15.25 13.5",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95605 17.875C9.26866 18.4165 9.26866 19.0835 8.95605 19.625L7.98633 21.3057C7.67379 21.847 7.09576 22.1805 6.4707 22.1807L4.5293 22.1807C3.90424 22.1805 3.32621 21.847 3.01367 21.3057L2.04395 19.625C1.75079 19.1172 1.73259 18.499 1.98926 17.9775L2.04395 17.875L3.01367 16.1943C3.32621 15.653 3.90424 15.3195 4.5293 15.3193L6.4707 15.3193C7.09576 15.3195 7.67379 15.653 7.98633 16.1943L8.95605 17.875Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 18.75,
    r: 2,
    stroke: "black",
    strokeWidth: 0.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5003 18C17.4169 17.0833 17.1753 15.025 16.8753 14.125C16.7352 13.7049 16.6737 13.0573 16.9982 12.4986C17.6547 11.3681 19.1352 11.1829 20.0822 12.0841V12.0841C20.9561 12.9157 20.2652 14.6559 19.9578 15.8224C19.7983 16.4277 19.6673 17.1628 19.6255 18",
    stroke: "black",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.25H22C22.9665 20.25 23.75 21.0335 23.75 22V23.75H13.25V22C13.25 21.0335 14.0335 20.25 15 20.25Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.1504H21C21.4694 18.1504 21.8496 18.5306 21.8496 19V19.8496H15.1504V19C15.1504 18.5306 15.5306 18.1504 16 18.1504Z",
    stroke: "black",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGRs);
export default __webpack_public_path__ + "static/media/GRs.5651576559625ceae063c83ab919c52e.svg";
export { ForwardRef as ReactComponent };